import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import campaignService from '../services/campaignService';
import { StyledUnSubscribeCampaign } from '../styles/GlobalStyles.styles';
import lgLogo from '../assets/nav/expandLogo.svg';
import Toast from '../components/molecules/Toast';

const UnsubscribeCampaign = () => {
  const { id } = useParams();

  const fetchData = async () => {
    try {
      await campaignService.unSubscribeCampaign(id);
    } catch (error) {
      Toast({ type: 'error', message: error.message || 'Failed to unsubscribe campaign' });
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <StyledUnSubscribeCampaign>
      <div className="content-holder">
        <div className="logo-holder">
          <img src={lgLogo} alt="logo" />
        </div>
        <h1>Unsubscribe Campaign</h1>

        <span className='text'>You’ve been unsubscribed. You will no longer receive emails from us.</span>
      </div>
    </StyledUnSubscribeCampaign>
  );
};

export default UnsubscribeCampaign;
